export const CustomerLimitQuery = "903f929aab0e9d240a03bd54db41c3fc0472947aa0a09abe0d0c9a4a99569cf4";